import React from 'react'

//Material-UI Core Components
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const customButtonStyles =  makeStyles(theme => ({
  root: {
    //marginLeft: 10,
    marginRight: 0,
    color: "#fff"
  }}));


function HeaderButton(props) {
  const classes = customButtonStyles();
  return (
    <Button classes={classes} color="secondary"  size="small" {...props}>
      {props.children}
    </Button>
  );
}

export default HeaderButton;